//Home page
export const GET_HOME = "GET_HOME";
export const GET_HOME_SUCCESS = "GET_HOME_SUCCESS";
export const GET_HOME_ERROR = "GET_HOME_ERROR";

export const REMOVE_BOOKMARK = "REMOVE_BOOKMARK";
export const GET_BOOKMARKS = "GET_BOOKMARKS";
export const GET_BOOKMARKS_SUCCESS = "GET_BOOKMARKS_SUCCESS";
export const GET_BOOKMARKS_ERROR = "GET_BOOKMARKS_ERROR";

export const GET_FOLLOWED_ALERTS_REQUEST = "GET_FOLLOWED_ALERTS_REQUEST";
export const GET_FOLLOWED_ALERTS_SUCCESS = "GET_FOLLOWED_ALERTS_SUCCESS";
export const GET_FOLLOWED_ALERTS_ERROR = "GET_FOLLOWED_ALERTS_ERROR";

// Mobile page
export const GET_MOBILE_REQUEST = "GET_MOBILE_REQUEST";
export const GET_MOBILE_SUCCESS = "GET_MOBILE_SUCCESS";
export const GET_MOBILE_ERROR = "GET_MOBILE_ERROR";

// All Alerts page
export const GET_ALERTS_REQUEST = "GET_ALERTS_REQUEST";
export const GET_ALERTS_SUCCESS = "GET_ALERTS_SUCCESS";
export const GET_ALERTS_ERROR = "GET_ALERTS_ERROR";
export const CACHE_PREVIOUS_CATEGORY_IDS = "CACHE_PREVIOUS_CATEGORY_IDS";
export const GET_CATEGORIES_REQUEST = "GET_CATEGORIES_REQUEST";
export const GET_CATEGORIES_SUCCESS = "GET_CATEGORIES_SUCCESS";
export const GET_CATEGORIES_ERROR = "GET_CATEGORIES_ERROR";
export const GET_SUBSCRIPTION_PLANS = "GET_SUBSCRIPTION_PLANS";
export const GET_SUBSCRIPTION_PLANS_SUCCESS = "GET_SUBSCRIPTION_PLANS_SUCCESS";
export const GET_SUBSCRIPTION_PLANS_ERROR = "GET_SUBSCRIPTION_PLANS_ERROR";
export const GET_SUBSCRIPTION_TEXT = "GET_SUBSCRIPTION_TEXT";
export const GET_SUBSCRIPTION_TEXT_SUCCESS = "GET_SUBSCRIPTION_TEXT_SUCCESS";
export const GET_SUBSCRIPTION_TEXT_ERROR = "GET_SUBSCRIPTION_TEXT_ERROR";
export const GET_SUBSCRIPTIONS = "GET_SUBSCRIPTIONS";
export const GET_SUBSCRIPTIONS_SUCCESS = "GET_SUBSCRIPTIONS_SUCCESS";
export const GET_SUBSCRIPTIONS_ERROR = "GET_SUBSCRIPTIONS_ERROR";
export const CREATE_SUBSCRIPTION = "CREATE_SUBSCRIPTION";
export const CREATE_SUBSCRIPTION_SUCCESS = "CREATE_SUBSCRIPTION_SUCCESS";
export const CREATE_SUBSCRIPTION_ERROR = "CREATE_SUBSCRIPTION_ERROR";
